// src/pages/WAHHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const WAHHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Skill Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Extra Income", emoji: "💰" },
    { label: "Skill Development", emoji: "📚" },
    { label: "Work & Selfcare", emoji: "⚡" },
    { label: "Shopping", emoji: "🛍️" },
    { label: "Games", emoji: "🎮" },
  ];

  const menuButtons1 = [
    // 💰 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/wah-bookworld", group: "Extra Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Extra Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Extra Income" },
    { label: "Resell", emoji: "♻️", link: "/wah-enroll", group: "Extra Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Extra Income" },
    { label: "ValueShare", emoji: "💾", link: "/orderflow-earning-estimator", group: "Extra Income" },

    // 📚 Skill Development
    { label: "Learning", emoji: "🗓️", link: "/wah-bookworld", group: "Skill Development" },
    { label: "Bookshelf", emoji: "📖", link: "/bookshelf", group: "Skill Development" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Skill Development" },

    // Work & Selfcare
    { label: "BlueHands", emoji: "👐", link: "/purplehands-home", group: "Work & Selfcare" },
    { label: "Tasks", emoji: "📖", link: "/wah-business-chronicles", group: "Work & Selfcare" },
    { label: "Diary", emoji: "📓", link: "/mydiary-home", group: "Work & Selfcare" },
    { label: "KRA-KPI", emoji: "📌", link: "", group: "Work & Selfcare" },
    { label: "WAH Ranking", emoji: "🏆", link: "/udyampragatiscore", group: "Work & Selfcare" },
    { label: "Speaking Card", emoji: "🎙️", link: "/contact-genious-speakingcard", group: "Work & Selfcare" },
    { label: "Paise Ka Help Chahiye", emoji: "💰", link: "/fundlanes", group: "Work & Selfcare" },
    { label: "PehchaanSetu", emoji: "🤝", link: "/pehchaansetu", group: "Work & Selfcare" },
    { label: "Bhaag Gaye DB", emoji: "📤", link: "/offboarded-home", group: "Work & Selfcare" },
    { label: "Paisa Nahin Diya DB", emoji: "🚫💰", link: "/offboarded-home", group: "Work & Selfcare" },
    
    // Shopping
    { label: "Khareedo", emoji: "🏪", link: "/orderflow-home", group: "Shopping" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Market & Engagement" },

    // Games
    { label: "Mind Fresh", emoji: "🧠", link: "", group: "Games" },
    { label: "Seekho", emoji: "⚙️", link: "", group: "Games" },
    { label: "Sawaal-Jawab", emoji: "🎯", link: "", group: "Games" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-purple-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">🙏 WAH</div>
          <div className="text-[11px] text-gray-200">Work Appreciation Hub! For Househelps and Households!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-purple-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WAHHome;
